module.exports = __webpack_public_path__ + "static/media/canari_logo_beach.22aff8cd.png";